import { Component, Input } from '@angular/core';

/**
 * Tarjeta blanca de resumen (la de Cumpleaños): ícono, título, bajada y,
 * opcionalmente, una barra de avance. La usan Cumpleaños (sin barra) y
 * Asistentes (con barra de registrados sobre vendidos).
 */
@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss'],
  standalone: false,
})
export class SummaryCardComponent {
  @Input() icon = 'calendar-outline';
  @Input({ required: true }) title!: string;
  @Input() subtitle = '';
  /** Avance de 0 a 1. Sin valor (null) no se dibuja la barra. */
  @Input() progress: number | null = null;
  /** Nombre accesible de la barra. */
  @Input() progressLabel = '';

  get progressPercent(): number {
    const value = Number(this.progress);
    if (!Number.isFinite(value)) return 0;
    return Math.round(Math.min(Math.max(value, 0), 1) * 100);
  }
}
